export const MESSAGE_TOKENS = {
  YOBI_SUPPORT: '||%yobi_support%||',
  YOBI_SUPPORT_PREVIEW: 'Yobi Support'
} as const; 